import React from "react";
import img from "../../assets/icons/team_icon-01-01.png";
import book from "../../assets/icons/book_svg-01.png";

import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";
const HomeProjects = () => {
  return (
    <section
      className="bg-[#EDF3F4] py-16 md:py-20 relative overflow-hidden"
      id="our-team"
    >
      {/* Decorative Images */}
      <img
        src={img}
        alt=""
        className="absolute top-0 left-0 w-24 md:w-36 opacity-20"
      />

      <img
        src={book}
        alt=""
        className="absolute bottom-0 right-0 w-28 md:w-44 opacity-20"
      />

      {/* Heading */}
      <div className="max-w-7xl mx-auto px-5 relative z-10">
        <div className="text-center">
          <p className="font-teacher text-[#005064] uppercase tracking-[5px] font-bold">
            Projects
          </p>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1a1a1a] mt-4 leading-tight">
            A Prestigious Project by
            <br />
            <span className="text-[#005064]">
              Sri Lakshmi Narasimha Educational Society (Regd.)
            </span>
          </h2>
        </div>

        {/* Project Card */}
        <div className="max-w-4xl mx-auto mt-12 bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 p-6 md:p-10">
          {/* School Icon */}
          <div className="flex justify-center">
            <div className="bg-[#005064] p-5 rounded-full shadow-md">
              <SchoolOutlinedIcon
                sx={{
                  color: "#fff",
                  fontSize: 42,
                }}
              />
            </div>
          </div>

          {/* Title */}
          <div className="text-center mt-6">
            <h2 className="text-2xl md:text-3xl font-bold text-[#1a1a1a]">
              Proposed International School
            </h2>

            <h3 className="text-xl font-semibold text-[#005064] mt-2">
              @Medchal – Gowdavally
            </h3>

            <div className="flex justify-center items-center gap-2 mt-5">
              <CalendarMonthOutlinedIcon
                sx={{
                  color: "#005064",
                }}
              />

              <p className="text-base md:text-lg font-medium text-gray-700">
                Coming Up for the Academic Year{" "}
                <span className="font-bold">2027–28</span>
              </p>
            </div>
            <p className="text-base md:text-lg font-medium text-gray-700">
              CBSE & Cambridge Curriculum
            </p>
          </div>

          {/* Divider */}
          <div className="w-24 h-1 bg-[#005064] rounded-full mx-auto my-8"></div>

          {/* Contact + Location */}
          <div className="grid lg:grid-cols-2 gap-8">
            {/* Left - Existing Location */}
            <div className="flex items-start gap-4">
              <LocationOnOutlinedIcon
                sx={{
                  color: "#005064",
                  fontSize: 34,
                  marginTop: "3px",
                }}
              />

              <div>
                <h4 className="text-xl font-semibold text-[#1a1a1a] mb-5">
                  Location
                </h4>
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3802.791921848222!2d78.45465000000002!3d17.612613!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTfCsDM2JzQ1LjQiTiA3OMKwMjcnMTYuNyJF!5e0!3m2!1sen!2sin!4v1783678490708!5m2!1sen!2sin"
                  className="w-full h-[250px] rounded-xl"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="strict-origin-when-cross-origin"
                  title="School Location"
                />
              </div>
            </div>

            {/* Right - Contact Details */}
            <div className="flex flex-col gap-5">
              {/* Phone */}
              <div className="flex items-center gap-4 bg-[#eef4f5] rounded-2xl p-5">
                <div className="w-12 h-12 bg-[#005064] rounded-2xl flex items-center justify-center">
                  <LocalPhoneIcon className="text-white" />
                </div>

                <div>
                  <h4 className="font-semibold text-lg">Contact Number</h4>

                  <a
                    href="tel:+919848433744"
                    className="text-[#005064] font-bold hover:opacity-70"
                  >
                    +91 98484 33744
                  </a>
                </div>
              </div>

              {/* Email */}
              <div className="flex items-center gap-4 bg-[#eef4f5] rounded-2xl p-5">
                <div className="w-12 h-12 bg-[#005064] rounded-2xl flex items-center justify-center">
                  <EmailOutlinedIcon className="text-white" />
                </div>

                <div>
                  <h4 className="font-semibold text-lg">Email Address</h4>

                  <a
                    href="mailto:info@slned.com"
                    className="text-[#005064] font-bold hover:opacity-70"
                  >
                    info@slned.com
                  </a>
                </div>
              </div>

              {/* Website */}
              <div className="flex items-center gap-4 bg-[#eef4f5] rounded-2xl p-5">
                <div className="w-12 h-12 bg-[#005064] rounded-2xl flex items-center justify-center">
                  <LanguageOutlinedIcon className="text-white" />
                </div>

                <div>
                  <h4 className="font-semibold text-lg">Website</h4>

                  <a
                    href="https://slned.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#005064] font-bold hover:opacity-70"
                  >
                    slned.com
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeProjects;
